import {
    FaYoutube,
    FaFacebookF,
    FaInstagram,
    FaPinterestP,
    FaDiscord,
  } from 'react-icons/fa';
  // import images
  import AboutImg from '../src/assets/img/about/plate.png';
  import ModelWhiteImg from '../src/assets/img/model-white.png';
  import ModelBlackImg from '../src/assets/img/model-black.png';
  import MenuImg1 from '../src/assets/img/menu/4.png';
  import MenuImg2 from '../src/assets/img/menu/2.png';
  import MenuImg3 from '../src/assets/img/menu/3.png';
  import MenuImg4 from '../src/assets/img/menu/4.png';
  import SignatureImg from '../src/assets/img/team/signature.png';
  import ChefImg from '../src/assets/img/team/chef.png';
  import Avatar1 from '../src/assets/img/testimonial/avatar1.png';
  import Avatar2 from '../src/assets/img/testimonial/avatar2.png';
  import Avatar3 from '../src/assets/img/testimonial/avatar3.png';
  
  export const navData = [
    { href: '/', name: 'home' },
    { href: '/', name: 'about' },
    { href: '/', name: 'menu' },
    { href: '/', name: 'team' },
    { href: '/', name: 'testimonials' },
    { href: '/', name: 'book a table' },
    { href: '/', name: 'contact' },
  ];
  
  export const heroData = {
    pretitle: 'Nothing is like',
    title: 'Bridge restaurant',
    subtitle:
      'command and reserve your table with us ',
    btnText: 'Find out more',
  };
  
  export const socialData = [
    { href: '/', icon: <FaYoutube /> },
    { href: '/', icon: <FaFacebookF /> },
    { href: '/', icon: <FaInstagram /> },
    { href: '/', icon: <FaPinterestP /> },
    { href: '/', icon: <FaDiscord /> },
  ];
  
  export const aboutData = {
    pretitle: 'our story',
    title: 'who we are',
    subtitle:
      'restaurant with delicious food of every category ,here you can eat every think you think about and find the best services and the hospitalite ',

    btnText: 'find out more',
    image: AboutImg,
  };
  
  export const menuData = {
    title: 'delicious flavour of autumn',
    subtitle: 'view all menu for tasty meal today',
    modelImg: ModelWhiteImg,
    btnText: 'view complete menu',
    menuItems: [
      {
        image: MenuImg1,
        name: 'Chocolate Cake',
        price: '$7.99',
        description: 'Class aptent taciti ciosqu litora torquent per Class aptent taciti ciosqu litora torq',
      },
      {
        image: MenuImg2,
        name: 'Veggie Burger',
        price: '$9.49',
        description: 'Class aptent taciti ciosqu litora torquent per',
      },
    
      {
        image: MenuImg3,
        name: 'King Burger',
        price: '$8.50',
        description: 'Class aptent taciti ciosqu litora torquent per',
      },
      {
        image: MenuImg4,
        name: 'Mexican Burger',
        price: '$9.99',
        description: 'Class aptent taciti ciosqu litora torquent per',
      },
    ],
  };
  
  export const teamData = {
    pretitle: 'our team',
    title: 'meet our chef',
    sub1: ' connect with our chef ',
    sub2: '',
    name: 'Zakaria Bouregbi',
    occupation: 'executive chef',
    signatureImg: SignatureImg,
    chefImg: ChefImg,

  };
  
  export const testimonialData = {
    title: "what client's say ",
    subtitle: '1500+ statisfied clients',
    modelImg: ModelWhiteImg,
    slider: [
      {
        message:
          'good qualite and nice hospitalite thanks to all of you guys ',

        image: Avatar1,
        name: 'Ben khaled',
        occupation: 'Crypto ',
      },
      {
        message:
          'thank you for this delicius food nice to meet the chef and all of you ',

        image: Avatar2,
        name: 'didin dd',
        occupation: 'CEO of Delightful',
      },
      {
        message:
          'good work ',
        image: Avatar3,
        name: 'zad A.',
        occupation: 'CEO of Delightful',
      },
    ],
  };
  
  export const reservationData = {
    title: 'booking form',
    subtitle:
      'Call (800) 123-4567 from 5AM - 11PM daily, or book online with OpenTable.Reservations required for parties of 6 or more.',
    modelImg: ModelBlackImg,
    btnText: 'make a reservation',
  };
  
  export const newsletterData = {
    title: 'join our newsletter',
    subtitle: 'Get latest news & updates in your inbox.',
    placeholder: 'Subscribe our delicious dishes',
    btnText: 'subscribe now',
  };
  
  export const footerData = {
    contact: {
      title: 'contact location',
      address: '140 Street ',
      phone: '(201)256-3689',
    },
    hours: {
      title: 'working hours',
      program: [
        {
          days: 'monday - friday',
          hours: '09:00 AM - 10:00 PM',
        },
        {
          days: 'saturday - sunday',
          hours: '09:00 AM - 11:00 PM',
        },
      ],
    },
    social: {
      title: 'social network',
      icons: [
        { href: '/', icon: <FaYoutube /> },
        { href: '/', icon: <FaFacebookF /> },
        { href: '/', icon: <FaInstagram /> },
        { href: '/', icon: <FaPinterestP /> },
        { href: '/', icon: <FaDiscord /> },
      ],
    },
  };